import React, { useEffect, useState } from 'react'
import SideBar from '../../Layout/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong, faArrowRight, faMagnifyingGlass, faUser } from '@fortawesome/free-solid-svg-icons';
import Transfer from './Transfer';
import Transactions from './Transactions';
import Earnings from './Earnings';
import Subcription from './Subcription';
import SupportTicket from './SupportTicket';
import Chat from './Chat';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { SERVER_URL } from '../../../config';
import toast from 'react-hot-toast';
import PlayerReport from './PlayerReport';

export default function ClubDashboard_II() {

    const [active, setActive] = useState('div0')
    const token = sessionStorage.getItem('club_token');
  const [isReportPopupOpen, setIsReportPopupOpen] = useState(false);
  const [players, setPlayers] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [reports, setReports] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


    const handleActivetab = (id) => {
        setActive(id);
    }

    const tabs = [
        { id: 'div1', label: 'TRANSFER' },
        { id: 'div2', label: 'TRANSACTIONS' },
        { id: 'div3', label: 'EARNINGS' },
        { id: 'div4', label: 'SUBSCRIPTION' },
        { id: 'div5', label: 'SUPPORT' },
        { id: 'div6', label: 'CHAT' },
    ]


  useEffect(() => {
    const fetchPlayers = async () => {
      if (!token) {
        toast.error('No authentication token found. Please log in.');
        setTimeout(() => {
          navigate('/club/login');
        }, 2000);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${SERVER_URL}/api/v2/club/get-all-players`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.status) {
          setPlayers(response.data.players || []);
        } else {
          toast.error('Failed to fetch players.');
          setError('Failed to fetch players.');
        }
      } catch (err) {
        const msg = err?.response?.data?.message || 'Something went wrong.';
        console.error('API Error:', msg);
        setError(msg);
        if (
          msg.includes('expired') ||
          msg.includes('invalidated') ||
          msg.includes('Invalid token') ||
          msg.includes('token is required')
        ) {
          setTimeout(() => {
            navigate('/club/login');
          }, 2000);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPlayers();
  }, [token, navigate]);



    const handleViewFullReport = () => {
        console.log("selectedPlayer",selectedPlayer)
    if (selectedPlayer.share_dna_data !== 1) {
      toast.error('Player has not provided access to view DNA data.');
      return;
    }
    setIsReportPopupOpen(true);
  };



    const mainPlayers = players.filter(
        (p) => p.position !== 'SUBSTITUTE PLAYERS' && p.position !== 'RESERVE PLAYER'
    );
    const subsAndReserves = players.filter(
        (p) => p.position === 'SUBSTITUTE PLAYERS' || p.position === 'RESERVE PLAYER'
    );

    const PlayerCard = ({ player }) => (
        <div onClick={() => setSelectedPlayer(player)} className='cursor-pointer'>
            <div className='w-[125px] h-[150px] overflow-hidden border rounded-xl mx-auto'>
                {player.photo ? (
                    <img src={player.photo} className='w-full h-full object-cover' alt={player.name} />
                ) : (
                    <div className='grid place-content-center h-full text-[#24FF00] cursor-pointer'>
                        <FontAwesomeIcon icon={faUser} className='text-lg' />
                        <FontAwesomeIcon icon={faMagnifyingGlass} className='bg-[#0E081B] rounded-full -translate-y-2 translate-x-2 text-sm' />
                    </div>
                )}
            </div>
            <p className='text-center mt-3 font-medium'>{player.name}</p>
            <p className='text-center text-sm text-white/60'>{player.position}</p>
        </div>
    );

    return (
        <div className='flex flex-col h-screen bg-[#0E081B] text-white'>
            <div className='flex flex-col flex-grow lg:flex-row overflow-hidden'>
                <SideBar />
                <div className='w-[100%] lg:w-[90%] p-5 lg:px-10 overflow-y-auto pt-10 lg:pt-20'>
                    <button className={`${active !== 'div0' ? 'visible -translate-y-5' : 'hidden'}`}>
                        <FontAwesomeIcon icon={faArrowLeftLong} className='' onClick={() => handleActivetab('div0')} />
                    </button>
                    <div className='flex overflow-x-auto'>
                        {tabs.map((item) => {
                            const { id, label, icon } = item;
                            return (
                                <div key={id} className={`flex-shrink-0 border uppercase border-white/15 rounded-t-xl px-10 py-1.5 flex items-center gap-3 cursor-pointer 
                                    ${active === id ? 'text-[#00FF00] font-semibold' : ''}`}
                                    onClick={() => handleActivetab(id)}>
                                    {label}
                                </div>
                            );
                        })}
                    </div>
                   
                     {active === 'div0' &&
                        <>
                            {!selectedPlayer && (
                            <>
                                <p className='mt-5 text-xl font-medium'>VIEW PLAYERS</p>

                                {/* ✅ Show "No players available" if no players exist */}
                                {mainPlayers.length === 0 && subsAndReserves.length === 0 ? (
                                <div className="mt-20 text-center text-white/70">
                                    <p className="text-2xl font-semibold text-[#24FF00]">🚀 No players available</p>
                                    <p className="mt-3 text-lg">Please add players to your club to get started.</p>
                                </div>
                                ) : (
                                <>
                                    {/* Main Players */}
                                    <div className='mt-5 flex flex-wrap justify-center gap-10'>
                                    {mainPlayers.map((player, index) => (
                                        <div key={index} onClick={() => setSelectedPlayer(player)} className='cursor-pointer'>
                                        <PlayerCard key={index} player={player} />
                                        </div>
                                    ))}
                                    </div>

                                    {/* Subs & Reserves */}
                                    <div className='mt-10'>
                                    <h2 className='text-lg font-semibold mb-4'>Substitute & Reserve Players</h2>
                                    <div className='flex flex-wrap justify-center lg:justify-start gap-10'>
                                        {subsAndReserves.map((player, index) => (
                                        <div key={index} onClick={() => setSelectedPlayer(player)} className='cursor-pointer'>
                                            <PlayerCard key={index} player={player} />
                                        </div>
                                        ))}
                                    </div>
                                    </div>
                                </>
                                )}
                            </>
                            )}

                            {selectedPlayer && (
                            <div className='mt-5'>
                                <div className='flex flex-col lg:flex-row gap-10 justify-between items-center'>
                                {/* Player Image */}
                                <div className='w-[100%] lg:w-1/3'>
                                    <div className='overflow-hidden border rounded-xl'>
                                    {selectedPlayer.photo ? (
                                        <img src={selectedPlayer.photo} className='w-full h-full object-cover' />
                                    ) : (
                                        <div className='grid place-content-center h-[380px] text-[100px]'>?</div>
                                    )}
                                    </div>
                                </div>

                                {/* Player Info */}
                                <div className='w-[100%] lg:w-1/3 space-y-7'>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Date Of Birth </p>
                                    {selectedPlayer.dateofbirth ? (
                                        <p className='font-semibold'>{selectedPlayer.dateofbirth}</p>
                                    ) : (<span>---------</span>)}
                                    </div>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Nationality </p>
                                    {selectedPlayer.nationality ? (
                                        <p className='font-semibold'>{selectedPlayer.nationality}</p>
                                    ) : (<span>---------</span>)}
                                    </div>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Club </p>
                                    <p className='font-semibold'>{selectedPlayer.club}</p>
                                    </div>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Matches </p>
                                    {selectedPlayer.matches ? (
                                        <p className='font-semibold'>{selectedPlayer.matches}</p>
                                    ) : (<span>---------</span>)}
                                    </div>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Goals </p>
                                    {selectedPlayer.goals ? (
                                        <p className='font-semibold'>{selectedPlayer.goals}</p>
                                    ) : (<span>---------</span>)}
                                    </div>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Tackles </p>
                                    {selectedPlayer.tackles ? (
                                        <p className='font-semibold'>{selectedPlayer.tackles}</p>
                                    ) : (<span>---------</span>)}
                                    </div>
                                    <div className='flex items-center justify-between'>
                                    <p className='font-light'>Price </p>
                                    {selectedPlayer.price ? (
                                        <p className='font-semibold text-[#00FF00]'>{selectedPlayer.price}</p>
                                    ) : (<span className='text-[#FF0000]'>Price not Updated</span>)}
                                    </div>
                                </div>

                                {/* DNA & Skill Analysis */}
                                <div className='w-[100%] lg:w-1/3'>
                                    <div className='bg-gradient-to-b from-[#2F1073] to-[#424C5F00] border text-center py-7 px-5 rounded-3xl h-full'>
                                    <img src='/assets/others/DNAanalysis.svg' className='mx-auto'></img>
                                    <p className='mt-5 text-xl font-semibold'>DNA & SKILL ANALYSIS</p>
                                    <p className='mt-2'>DNA Validated & Secured as NFT.</p>
                                    </div>
                                </div>
                                </div>

                                {/* Footer Info */}
                                <div className='flex flex-col lg:flex-row gap-10 mt-7 items-center'>
                                <div className='w-[100%] lg:w-1/3'>
                                   
                                    {selectedPlayer.name ? (
                                    <p className='text-4xl font-semibold'>{selectedPlayer.name}</p>
                                    ) : (<span className='text-4xl font-semibold'>NO DATA</span>)}
                                </div>
                                <div className='w-[100%] lg:w-1/3'>
                                    <p>Position</p>
                                    {selectedPlayer.position ? (
                                    <p className='text-4xl font-semibold'>{selectedPlayer.position}</p>
                                    ) : (<span className='text-4xl font-semibold'>NO DATA</span>)}
                                </div>
                                 <div className="w-[100%] lg:w-1/3 flex space-x-4">
                          {/* <button
                            onClick={() => setSelectedPlayer(null)}
                            className="border rounded-full flex items-center p-[2px] pl-5 flex-1"
                          >
                            SKILL METRICS
                            <div className="ml-5 w-8 h-8 grid place-content-center bg-white text-black rounded-full">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </div>
                          </button> */}
                          <div className="flex w-full justify-center items-center">
                            <button
                              onClick={handleViewFullReport}
                              disabled={selectedPlayer.share_dna_data !== 1}
                              className={`border  rounded-full flex  justify-center items-center p-[2px] pl-5 w-52 ${
                                selectedPlayer.share_dna_data !== 1
                                  ? 'opacity-50 cursor-not-allowed'
                                  : ''
                              }`}
                              title={
                                selectedPlayer.share_dna_data !== 1
                                  ? 'Player has not provided access to view DNA data.'
                                  : 'View full DNA report'
                              }
                            >
                              PLAYER REPORT
                              <div className="ml-5 w-8 h-8 grid place-content-center bg-white text-black rounded-full">
                                <FontAwesomeIcon icon={faArrowRight} />
                              </div>
                            </button>
                          </div>
                        </div>
                                </div>
                            </div>
                            )}
                        </>
                        }

                    {active === 'div1' && <Transfer />}
                    {active === 'div2' && <Transactions />}
                    {active === 'div3' && <Earnings />}
                    {active === 'div4' && <Subcription/>}
                    {active === 'div5' && <SupportTicket/>}
                    {active === 'div6' && <Chat/>}
                </div>
      {isReportPopupOpen && selectedPlayer && (
         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-[#0E081B] mt-14 lg:mt-4 p-6 rounded-3xl max-w-7xl w-full max-h-[90vh] overflow-y-auto relative">
            <button
              onClick={() => setIsReportPopupOpen(false)}
              className="absolute top-5 left-5 text-white"
            >
              <FontAwesomeIcon icon={faArrowLeftLong} className='text-lg'/>
            </button>
            <PlayerReport playerId={selectedPlayer.player_id} />
          </div>
        </div>
      )}
            </div>
        </div >
    )
}
